import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components/common/Button/Button";
import { CircularProgress } from "@mui/material";
import {
  SimpleCardContainer,
  SimpleCardContent,
  SimpleCardTitle,
} from "../../components/common/SimpleCard/SimpleCard";
import {
  isIzinMajuSidangButtonExist,
  isLihatBerkasButtonExist,
  isNilaiOrEvaluasiButtonExist,
  isAssignJadwalButtonExist,
  isEditAssignJadwal,
  isLembarAndLabelExist,
} from "./AccessValidationByKodeStatus";
import { KODE_STATUS_TYPE } from "../constants/StatusType.constants";
import MKSpesialService from "../../services/Integration/mkspesial/MKSpesialService";
import DetailProgressTable from "./DetailProgressTable";
import DOSEN_ROLES from "../constants/DosenRoles.constants";
import IzinMajuSidangCard from "../../views/dosen/sidang/sidang-list/IzinMajuSidangCard";
import BerkasSidangCard from "./BerkasSidangCard";
import JadwalSidangService from "../../services/Integration/jadwal-sidang/JadwalSidangService";
import DetailProgressPostSidangAdmin from "./DetailProgressPostSidangAdmin";

const infoJadwalSidangInitialState = {
  mk_spesial: null,
  penguji: [],
  tanggal: null,
  jam_mulai: null,
  jam_selesai: null,
  ruangan: null,
  is_sidang_online: false,
  link_vicon: null,
  keterangan: null,
  is_plagiarisme: false,
  is_siap_sidang: false,
  is_sidang_ulang: false,
  kirim_notifikasi: false,
};

const DashboardDetailPanel = ({
  rowData,
  dosenRole,
  term,
  sekreRole = false,
}) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [detail, setDetail] = useState({
    progress: {
      pra_sidang: [],
      post_sidang: [],
    },
    dosen: {
      pembimbing: [],
      penguji: [],
    },
    evaluasi: [],
  });
  const [infoJadwalSidang, setInfoJadwalSidang] = useState(
    infoJadwalSidangInitialState
  );

  useEffect(async () => {
    await getDetailMKSpesial();
    if (isAturJadwalExists()) {
      await getInfoAturJadwal();
    }
    setIsLoading(false);
  }, []);

  const getDetailMKSpesial = async () => {
    await MKSpesialService.getDetailMKSpesial(rowData.id_mk_spesial)
      .then((response) => {
        if (response.status === 200) {
          setDetail(response.data);
        } else {
          console.log(response);
        }
      })
      .catch((error) => console.log(error));
  };

  const getInfoAturJadwal = async () => {
    await JadwalSidangService.getJadwalSidangByMKSpesialId(
      rowData.id_mk_spesial
    )
      .then((response) => {
        if (response.status === 200) {
          setInfoJadwalSidang(response.data[0]);
        } else {
          console.log(response);
        }
      })
      .catch((error) => console.log(error));
  };

  function dosenObjectList(data) {
    const fullnames = [];
    data.forEach((dosen) => fullnames.push({ nama_lengkap: dosen }));
    return fullnames;
  }

  function isAturJadwalExists() {
    if (sekreRole && isAssignJadwalButtonExist(rowData.kode_status)) {
      return true;
    }
    return false;
  }

  function getStateForNilaiOrEvaluasi() {
    return {
      mKSpesialId: rowData.id_mk_spesial,
      dosenRole: dosenRole,
      jenisSidang: rowData.jenis_mk_spesial,
      judul: rowData.judul,
      mahasiswa: rowData.anggota,
      pembimbing: dosenObjectList(detail.dosen && detail.dosen.pembimbing),
      penguji: dosenObjectList(detail.dosen && detail.dosen.penguji),
    };
  }

  return (
    <>
      {isLoading ? (
        <div className="flex justify-center">
          <CircularProgress />
        </div>
      ) : (
        <div className="p-4 bg-slate-50">
          <div className="flex flex-row gap-8">
            <SimpleCardContainer className="max-w-md">
              <SimpleCardTitle>Pra-Sidang</SimpleCardTitle>
              <SimpleCardContent>
                <DetailProgressTable detail={detail.progress.pra_sidang} />
              </SimpleCardContent>
            </SimpleCardContainer>

            <SimpleCardContainer className="max-w-md">
              <SimpleCardTitle>Pasca-Sidang</SimpleCardTitle>
              <SimpleCardContent>
                {sekreRole ? (
                  <DetailProgressPostSidangAdmin
                    detail={detail.progress.post_sidang}
                  />
                ) : (
                  <DetailProgressTable detail={detail.progress.post_sidang} />
                )}
              </SimpleCardContent>
            </SimpleCardContainer>

            {!sekreRole && (
              <SimpleCardContainer className="max-w-md">
                <SimpleCardTitle>Informasi Dosen</SimpleCardTitle>
                <SimpleCardContent>
                  <div>
                    <b>Pembimbing</b>
                    {detail.dosen.pembimbing.length === 0 ? (
                      <p>-</p>
                    ) : (
                      <ul className="ml-4 list-disc">
                        {detail.dosen.pembimbing.map((dosbing, index) => (
                          <li key={index}>{dosbing}</li>
                        ))}
                      </ul>
                    )}

                    <b>Penguji</b>
                    {detail.dosen.penguji.length === 0 ? (
                      <p>-</p>
                    ) : (
                      <ul className="ml-4 list-disc">
                        {detail.dosen.penguji.map((dosji, index) => (
                          <li key={index}>{dosji}</li>
                        ))}
                      </ul>
                    )}
                  </div>
                </SimpleCardContent>
              </SimpleCardContainer>
            )}

            <SimpleCardContainer className="max-w-md">
              <SimpleCardTitle>Aksi</SimpleCardTitle>
              <SimpleCardContent>
                {rowData.kode_status ===
                KODE_STATUS_TYPE.KODE_ETIK_DAN_ATAU_BERKAS_BELUM_DIISI ? (
                  <p className="text-center">
                    Tidak ada aksi yang dapat dilakukan
                  </p>
                ) : (
                  <div className="flex flex-col space-y-4 items-center">
                    {dosenRole === DOSEN_ROLES.pembimbing &&
                      isIzinMajuSidangButtonExist(rowData.kode_status) && (
                        <IzinMajuSidangCard
                          mKSpesialId={rowData.id_mk_spesial}
                        />
                      )}

                    {!sekreRole &&
                      isNilaiOrEvaluasiButtonExist(rowData.kode_status) && (
                        <Button
                          color="blue"
                          onClick={() =>
                            navigate("/sidang/nilai", {
                              state: getStateForNilaiOrEvaluasi(),
                            })
                          }
                        >
                          Nilai
                        </Button>
                      )}

                    {!sekreRole &&
                      isNilaiOrEvaluasiButtonExist(rowData.kode_status) && (
                        <Button
                          color="blue"
                          onClick={() =>
                            navigate("/sidang/evaluasi", {
                              state: getStateForNilaiOrEvaluasi(),
                            })
                          }
                        >
                          Revisi
                        </Button>
                      )}

                    {isAturJadwalExists() && (
                      <Button
                        color="blue"
                        onClick={() =>
                          navigate("/sidang/jadwal-sidang/form", {
                            state: {
                              term: term,
                              idMkSpesial: rowData.id_mk_spesial,
                              rowData: infoJadwalSidang,
                              isEdit: isEditAssignJadwal(rowData.kode_status),
                              fromDashboard: true,
                            },
                          })
                        }
                      >
                        Atur Jadwal
                      </Button>
                    )}

                    {isLihatBerkasButtonExist(rowData.kode_status) && (
                      <Button
                        color="orange"
                        onClick={() =>
                          navigate(`/sidang/berkas/${rowData.id_mk_spesial}`, {
                            state: {
                              mKSpesialId: rowData.id_mk_spesial,
                              jenisSidang: rowData.jenis_mk_spesial,
                              judul: rowData.judul,
                              mahasiswa: rowData.anggota,
                            },
                          })
                        }
                      >
                        Lihat Detail Berkas
                      </Button>
                    )}

                    {sekreRole &&
                      isLembarAndLabelExist(rowData.kode_status) && (
                        <BerkasSidangCard 
                          mKSpesialId={rowData.id_mk_spesial} 
                          jenisSidang={rowData.jenis_mk_spesial} 
                        />
                      )}
                  </div>
                )}
              </SimpleCardContent>
            </SimpleCardContainer>
          </div>
        </div>
      )}
    </>
  );
};

export default DashboardDetailPanel;
